import { ChartTypes } from '../ChartTypes';
import type { AnalysisSubstep, AnalysisStep } from './AnalysisStep';

export const FACTOR_DECOMPOSITION_TABLE: AnalysisSubstep = {
  title: 'Factor Decomposition',
  path: 'regression-table',
  graphTypes: [
    ChartTypes.FACTOR_HEATMAP,
    ChartTypes.RETURN_ATTRIBUTION,
    ChartTypes.REGRESSION_TRACK,
    ChartTypes.CUMULATIVE_RESIDUAL,
  ],
};

export const FACTOR_DECOMPOSITION_ROLLING: AnalysisSubstep = {
  title: 'Rolling',
  path: 'rolling',
};

export const FACTOR_COMPARISON: AnalysisSubstep = {
  title: 'Factor Comparison',
  path: 'factor-comparison',
};

export const FACTOR_DECOMPOSITION: AnalysisStep = {
  name: 'Factor Decomposition',
  baseRoute: '/factor-decomposition',
  route: '/factor-decomposition',
  disabled: false,
  substeps: [FACTOR_DECOMPOSITION_TABLE, FACTOR_COMPARISON, FACTOR_DECOMPOSITION_ROLLING],
  icon: 'chart-area',
  mobileOnly: false,
  defaultSubstepPath: FACTOR_DECOMPOSITION_TABLE.path,
};
